<template>
  <div class="cooccurences">
    <br />
    <span v-if="store.state.lowLevelTerm">
      The following terms have been tagged along with the term: {{ store.state.lowLevelTerm }} in the database
      <br/>
    </span>
 
      <span
        @click="updateLowLevelSearch(term.label)"
        class="term lowlevel"
        v-for="(term, index) in filteredLowLevel"
        :key="index"
      >
        {{ term.label }} -
       <span class="term-count">{{ term.count }}</span>
      
     
      <br />
    </span>
 
    <br />
    <br />
    <span class="main-topic-suggestions" v-if="store.state.lowLevelTerm != ''">
      The term: {{ store.state.lowLevelTerm }} is part of the Main Topic: {{ store.state.midLevelTerm  }}, which contains
      following terms:
    </span>
          <!--<em>
        <strong
          @click="store.update_search(store.state.midLevelTerm)"
          style="cursor: pointer; text-transform: capitalize"
          >{{ store.state.midLevelTerm }}</strong
        > </em
      >, which has the following sub-topics:<br
    /></span>
    <span v-else
      >The Main Topic: {{ store.state.midLevelTerm }}, which contains
      following terms:</span
    >
    -->
    <br />
    <div>
       <span v-for="(category, index) in topics" :key="index">
        <div v-if="category.term=== store.state.midLevelTerm">
        <span class="tagsList">
          <li v-for="(tag, index) in category.lowLevel" :key="index">
            <a @click="setMetaData(category.term, tag)"
              class="button tag-list"
              >{{ tag }}
              </a
            >
          </li>
        </span>

      </div>
    </span>
    </div>
  </div>
</template>

<script>
//@ refers to the root directory.

import { store } from "@/store";
import termsLowLevel from "@/assets/low.json";
// import { terms } from "@/assets/co-occurences";
import topics from "@/assets/topics.json";
export default {
  data() {
    return {
      topics,
      store,
      // terms,
      termsLowLevel
    };
  },
  components: {},
  methods: {
    updateLowLevelSearch(item) {
      store.history.lowLevelTerm = store.state.lowLevelTerm;
      store.history.midLevelTerm = store.state.midLevelTerm;
      store.history.searchLevel = store.state.searchLevel;
      store.getMidlevelTermFromLowlevel(item);
      store.state.lowLevelTerm = item;
      store.state.searchLevel = "low";
      window.scrollTo(0,0)
    },
     setMetaData(midLevel, lowLevel) {
      this.store.state.lowLevelTerm = lowLevel;
      this.store.state.midLevelTerm = midLevel;
      this.store.getFilteredArticles();
      this.store.state.showResultsTable = true;
      this.store.getAssociatedTerms(this.store.state.lowLevelTerm);
      window.scrollTo(0,0)
    }
  },
  computed: {
    //SOFYA REWROTE IT TO SHOW HOW MANY COOOCCURRENCES ARE IN LOW.JSON FILE
    filteredLowLevel() {
      let filtered = [];
      let tags = store.getLowLevelOccurences();
      tags.map(tag => {
        console.log(tag);
        let count = tag[1];
        // This removes category from being shown in co-occurences
        if (tag[0] != "category"){
          let obj = { label: tag[0], count};
          filtered.push(obj);
        }
      })

// THIS IS TO SHOW HOW MANY ARTICLES ARE ASSOCIATED WITH EACH OF THESE COOCURRENCES
      // tags.map(tag => {
      //   let count = store.getArticleCountForTerm(tag[0]);
      //   if (count != 0) {
      //     let obj = { label: tag[0], count };
      //     filtered.push(obj);
      //   }
      // });
      return filtered;
    },

    filteredMidLevel() {
      let filtered = [];
      let tags = store.getMidLevelOccurences();
      tags.map(tag => {
        let count = store.getArticleCountForTerm(tag[0]);
        if (count != 0) {
          let obj = { label: tag[0], count };
          filtered.push(obj);
        }
      });
      return filtered;
    }
  }
};
</script>
<style scoped>

.button.tag-list {
  border: 1px solid #268491;
  -webkit-border-radius: 17px;
  -moz-border-radius: 17px;
  -ms-border-radius: 17px;
  border-radius: 17px;
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  color: #268491;
  transition: all 0.25s;
  outline: none;
  font-weight: bold;
  margin-right: 10px;
  margin: 10px;
  padding: 10px;
  height: 10px;
  text-decoration: none;
  text-transform: capitalize;
  cursor: pointer;
}
.button.tag-list:hover {
  background: white;
  color: #0a3a4a;
}

.tagsList {
  display: flex;
  flex-wrap: wrap;
}


</style>
